import { useEffect, useState } from 'react'

type BreakPointPxValue = {
  min?: number
  max?: number
}

export const useMediaQuery = (min: BreakPointPxValue, max: BreakPointPxValue) => {
  const [targetReached, setTargetReached] = useState(false)

  useEffect(() => {
    const createMediaQuery = () => {
      const mediaQuery: string[] = []

      min && mediaQuery.push(`(min-width: ${min.min}px)`)
      max && mediaQuery.push(`(max-width: ${max.max}px)`)

      return mediaQuery.join(' and ')
    }

    const media = window.matchMedia(createMediaQuery())

    if (media.matches !== targetReached) {
      setTargetReached(media.matches)
    }

    const listener = () => setTargetReached(media.matches)

    window.addEventListener('resize', listener)

    return () => window.removeEventListener('resize', listener)
  }, [targetReached, min, max])

  return targetReached
}
